// packages/content/src/strings/decor.ts (M1-T16) — decorate mode, the door setting, and the mayor's yard tidy-up (Contract change 29)
import type { StringBank } from '../schema/strings';
export default {
  title: 'Decorate', yardTitle: 'Decorate the yard', done: 'Done', turn: 'Turn', putAway: 'Put away',
  tabFurniture: 'Furniture', tabRugs: 'Rugs', tabWallpaper: 'Wallpaper', tabFloors: 'Floors',
  tray: 'Pockets and storage', emptyTray: 'Nothing to place. The shop has new pieces every morning.',
  apply: 'Use this', current: 'On the walls now: {name}', currentFloor: 'On the floor now: {name}',
  doorTitle: 'Front door', doorNote: 'Who can come in when you are not around?', verbLeave: 'Leave',
  tidyConfirm: 'Send the {object} back to {owner}? It goes to their storage, or comes to them by letter if that is full.',   // Contract change 29
  tidyDone: 'Sent home to {owner}.',
} as const satisfies StringBank;
